import React, { Component } from "react";
import { withRouter } from "./withRouterWrapper";

class SubCourseComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      siteLanguage: "",
    };
  }
  componentDidMount() {
    const siteLanguage = localStorage.getItem("siteLanguage") || "en";
    this.setState.siteLanguage = siteLanguage;
  }
  render() {
    const { location } = this.props;
    const post = location.state?.post;
    return (
      <div
        className={`container-fluid team py-3 ${
          this.setState.siteLanguage === "ur" ? " direction-rtl" : ""
        }`}
      >
        <div className="container">
          {/* Section Title */}
          <div
            className="text-center mx-auto mb-3 wow fadeIn"
            data-wow-delay="0.1s"
            style={{ maxWidth: "700px" }}
          >
            <h4 className="fw-normal fst-italic text-primary my-2">
              {post.title}
            </h4>
          </div>
          {/* Main Team Layout */}
          <div className="row g-5">
            {/* Main Team Leader */}
            <div className="col-lg-4 col-xl-5">
              <div className="team-img wow zoomIn" data-wow-delay="0.1s">
                <img src={post.image} className="img-fluid" alt={post.image} />
              </div>
            </div>
            <div className="col-lg-8 col-xl-7">
              <div className="team-item wow fadeIn" data-wow-delay="0.1s">
                <h1>{post.title}</h1>
                {/* <h5 className="fw-normal fst-italic text-primary mb-4">
                  {post.title}
                </h5> */}

                <h5 className="fst-italic mb-2">{post.class_length_minute}</h5>
                <h5 className="fst-italic mb-2">{post.duration_in_month}</h5>
                <h5 className="fst-italic mb-2">{post.language}</h5>

                {post.sections.map((items) => (
                  <>
                    <h6 className="fw-normal fst-italic text-primary">
                      {items.title}
                    </h6>
                    {items.content.split("\n").map((line, index) => (
                      <p className="mb-2" key={index}>
                        <i className="fa fa-check text-primary me-2"></i>
                        {line}
                      </p>
                    ))}
                  </>
                ))}
                <div className="col-12 my-4">
                  <a href="/student-registration">
                    <button
                      className="btn btn-primary border-1-primary py-3 px-5"
                      type="submit"
                    >
                      {this.setState.siteLanguage === "ur"
                        ? "ابھی رجسٹر کریں۔"
                        : this.setState.siteLanguage === "ro"
                        ? "Register Now"
                        : "Register Now"}
                    </button>
                  </a>
                </div>
              </div>

              {/* Additional Team Members */}
              {/* <div className="row g-4">
                {teamData.slice(1).map((member, index) => (
                  <div className="col-md-4" key={index}>
                    <div className="team-item wow zoomIn" data-wow-delay={`${0.2 + index * 0.2}s`}>
                      <img src={member.image} className="img-fluid w-100" alt={member.name} />
                      <div className="team-content text-dark text-center py-3">
                        <div className="team-content-inner">
                          <h5 className="mb-0">{member.name}</h5>
                          <p className="text-dark">{member.role}</p>
                          <div className="team-icon d-flex align-items-center justify-content-center">
                            <a className="btn btn-primary btn-sm-square me-2" href={member.socialLinks.facebook}>
                              <i className="fab fa-facebook-f"></i>
                            </a>
                            <a className="btn btn-primary btn-sm-square me-2" href={member.socialLinks.twitter}>
                              <i className="fab fa-twitter"></i>
                            </a>
                            <a href={member.socialLinks.instagram} className="btn btn-primary btn-sm-square me-2">
                              <i className="fab fa-instagram"></i>
                            </a>
                            <a href={member.socialLinks.linkedin} className="btn btn-primary btn-sm-square">
                              <i className="fab fa-linkedin-in"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div> */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(SubCourseComponent);
